<script lang="ts">
import htmlFromConfig from "../components/menu/HtmlFromConfig.vue";

export default {
  name: 'MentionsLegales',
  setup() {
    useHead({
      title: 'Mentions Légales',
    })
  },
  components: {
    htmlFromConfig,
  },
}
</script>

<template>
  <html-from-config class="contenu-html" html-name="mention_legales" />
</template>

<style>
.contenu-html p::before {
    content: '\200B'; /* Ajoute un espace invisible "Zero Width Space" */
    display: inline-block;
    width: 0;
}
</style>

